import { createActions } from '../utils/actions';

const { actions: affiliate } = createActions('affiliate')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('getHistory')
  .addAsync('getLink')
  .addAsync('getPayout')
  .addAsync('requestPayout')
  .addAsync('sendApply')
  .add('setData');

export default affiliate;
